import React, { FC } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { BaseControlProps } from '../../../types/controls';
import { SEEK_INTERVAL } from '../../../constants/skin';
import { useRestrictedSeekWithIndicator } from '../../../hooks/skin/use-restricted-seek-with-indicator';

import styles from './styles.module.css';

interface Props extends BaseControlProps {
    type: 'backward' | 'forward';
    className?: string;
}

export const SeekButton: FC<Props> = ({ className, type, onClick }) => {
    const { seekBackward, seekForward } = useRestrictedSeekWithIndicator();
    const intl = useIntl();
    const isBackward = type === 'backward';
    const ariaLabel = isBackward
        ? intl.formatMessage(
              {
                  id: 'features.player.ea6d6a9fcf09d03f82ec704350065c1d',
                  defaultMessage:
                      '{seconds} {seconds, plural, one {second} few {seconds} other {seconds}} back',
                  description: 'Ариа атрибут для кнопки перемотки с секундами',
              },
              { seconds: SEEK_INTERVAL }
          )
        : intl.formatMessage(
              {
                  id: 'features.player.2759d5c4110291f2258b22cdcf66f2ea',
                  defaultMessage:
                      '{seconds} {seconds, plural, one {second} few {seconds} other {seconds}} forward',
                  description: 'Ариа атрибут для кнопки перемотки с секундами',
              },
              { seconds: SEEK_INTERVAL }
          );

    return (
        <button
            aria-label={ariaLabel}
            onClick={() => {
                (isBackward ? seekBackward : seekForward)();
                onClick?.();
            }}
            className={classnames(styles.root, className, styles[type])}
        >
            <span className={styles.skipInterval}>{SEEK_INTERVAL}</span>
        </button>
    );
};
